<script>
import Vue from 'vue';
import {mapState, mapActions} from 'vuex';
import AdminEditModalForm from '../AdminEditModalForm/AdminEditModalForm.vue';

export default Vue.extend({
    components: {
        AdminEditModalForm
    },
    computed: {
        ...mapState({
            open: state => state.admin.editModal.open
        })
    },
    methods: {
        ...mapActions({
            toggleEditModal: 'admin/toggleEditModal'
        }),
        toggleModal($event) {
            if($event.target.id === 'container') {
                this.toggleEditModal();
            }
        }
    }
});
</script>
<template>
    <transition name="fade" mode="out-in">
        <div v-if="open" class="admin-edit-modal">
            <div id="container" class="admin-edit-modal__container" @click="toggleModal($event)">
                <div class="admin-edit-modal__content">
                    <div class="admin-edit-modal__header">
                        <div class="admin-edit-modal__heading">
                            {{ $t('admin.edit.header.heading') }}
                        </div>
                        <div class="manage-allocation-modal__toggle" @click="toggleEditModal()">
                            <i class="fa fa-times-circle"/>
                        </div>
                    </div>
                    <div class="admin-edit-modal__body">
                        <admin-edit-modal-form/>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>



// WEBPACK FOOTER //
// src/components/AdminEditModal/AdminEditModal.vue